// extracted by mini-css-extract-plugin
export default {"name":"jcdpl"};